// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Component, Input, OnInit } from '@angular/core';
import { HARDWARE2_PRODUCT_PLAN_ID, ISubscription } from '../../../../types/subscription';
import { IIncludedSoftware } from '../products.component';
import {IManageUser, UserRole} from '../../../../types/user';
import {Observable} from 'rxjs';
import {selectUser} from '../../../store/user/user.selectors';
import {Store} from '@ngrx/store';
import {AppState} from '../../../store/app.state';

@Component({
    selector: 'app-hardware-sub',
    templateUrl: './hardware-sub.component.html',
    styleUrls: ['./hardware-sub.component.scss', '../products.component.scss'],
    standalone: false
})
export class HardwareSubComponent implements OnInit {
  user$: Observable<IManageUser> = this.store.select(selectUser())
  @Input() subscription: ISubscription;
  @Input() title: string;
  columnsToDisplay = ['productName', 'assignedLicenses', 'purchasedQuantity'];
  data: IIncludedSoftware[] = [];

  constructor(private readonly store: Store<AppState>) {
  }

  raid = false;
  ngOnInit() {
    if (this.subscription.stripe_product.stripe_product_id === HARDWARE2_PRODUCT_PLAN_ID) {
      this.raid = true;
    }

    this.data = [
      {
        productName: "Cigent CLI",
        assignedLicenses: 0,
        licensesApply: false,
        purchasedQuantity: this.subscription.count,
        hasEndpoints: false,
        canAssign: false,
        hiddenForPartners: [],
      },
      {
        productName: "Pre-Boot Authentication",
        assignedLicenses: this.subscription.pba_used,
        licensesApply: true,
        purchasedQuantity: this.subscription.count,
        hasEndpoints: false,
        canAssign: true,
        hiddenForPartners: [],
      },
    ];
  }

  protected readonly UserRole = UserRole;
}
